import { css } from 'styled-system/css';

export const galaxyDefaultStakeStyle = {
	item: css({
		base: {
			color: 'var(--body-text)',
			'--row-border': { base: 'var(--lv1-8)', _dark: 'rgba(0, 0, 0, 0.12)' },
			borderBottom: '1px solid var(--row-border)',
		},
	}),
	row: css({
		base: {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			cursor: 'pointer',
			gap: '12px',
		},
	}),
	stakeInput: css({
		
		base: {
			'& .stake-input': {
				bgColor: 'var(--s700)'
			},
			p: '9px'
		}
	})
};